import React, { useState } from 'react';
import './ServerIP.css';

function ServerIP() {
  const [copied, setCopied] = useState(false);
  const serverIp = 'play.voxale.net';

  const copyIP = async () => {
    try {
      await navigator.clipboard.writeText(serverIp);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback
      const textarea = document.createElement('textarea');
      textarea.value = serverIp;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="ip-section">
      <span className="ip-label">Server Address</span>
      <div className="ip-address" onClick={copyIP}>{serverIp}</div>
      <p className={`copy-hint ${copied ? 'copied' : ''}`}>
        {copied ? '✓ Copied!' : 'Click to copy'}
      </p>
    </div>
  );
}

export default ServerIP;
